import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getStatistics } from "./../Apis/Statistics/Statistics";

export const fetchStatistics = createAsyncThunk(
  "statistics/fetchStatistics",
  async ({ forUsers, forReservation }) => {
    const response = await getStatistics({ forUsers, forReservation });
    return response;
  }
);

const initialState = {
  reservationsNumber: 0,
  usersNumber: 0,
  profit: [],
  dailyBookings: [],
  popularPackages: [],
  isLoading: false,
  error: null,
};

const statisticsSlice = createSlice({
  name: "statistics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStatistics.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchStatistics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.reservationsNumber = action.payload.reservationsNumber || 0;
        state.usersNumber = action.payload.usersNumber || 0;
        state.profit = action.payload.profit || [];
        state.dailyBookings = action.payload.dailyBookings || [];
        state.popularPackages = action.payload.popularPackages || [];
      })
      .addCase(fetchStatistics.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        console.error("Error fetching statistics:", action.error);
      });
  },
});

export default statisticsSlice.reducer;